import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Select,
  Form,
  DatePicker,
  Col,
  Divider,
  Button,
  Spin,
  Transfer,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { LeftOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../configurations/configurations.config";
import CustomButton from "../../../components/custom/CustomButton";
import appStatic from "../../../config/appStatic";
import dayjs from "dayjs";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const { TextArea } = Input;

const EditHoliday = (props) => {
  const { userData } = props;
  const { session } = userData;
  const { monthList } = appStatic;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const isSpecifiedDateOption = Form.useWatch("reschedulingType", useForm);

  const { state } = useLocation();
  const [rescheduleTypeData, setRescheduleTypeData] = useState([]);
  const [holidayDetail, setHolidayDetail] = useState([]);
  const [isSpecifiedDate, setIsSpecifiedDate] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getTemplate();
    getDetailById();
  }, []);

  function getTemplate() {
    const url = `${apiConfig.Holidays}/template`;

    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            value: element?.id,
            label: element?.value,
          });

          setRescheduleTypeData(tempArray);
        });
      }
    });
    setIsLoading(false);
  }

  function getDetailById() {
    const url = `${apiConfig.Holidays}/${state.id}`;

    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        setIsLoading(false);
        const objList = res;
        setHolidayDetail(objList);

        useForm.setFieldsValue({
          name: objList?.name,
          fromDate: objList.fromDate
            ? dayjs(BOM.FormatArrayDate(objList.fromDate))
            : objList.fromDate,
          toDate: objList.toDate ? dayjs(BOM.FormatArrayDate(objList.toDate)) : objList.toDate,
          reschedulingType: objList?.reschedulingType,
          repaymentsRescheduledTo: objList.repaymentsRescheduledTo
            ? dayjs(BOM.FormatArrayDate(objList.repaymentsRescheduledTo))
            : objList.repaymentsRescheduledTo,
          description: objList?.description,
        });
      }
    });
  }

  function onCancel() {
    navigate("/manage-holidays", { state: state });
  }

  const handleRepaymentSchedulingTypeChange = (valueParam) => {
    if (valueParam === 2) {
      setIsSpecifiedDate(true);
    } else {
      setIsSpecifiedDate(false);
    }
  };

  const onSubmit = (formValues) => {
    formValues.repaymentsRescheduledTo = formValues.repaymentsRescheduledTo
      ? BOM.DateTime(formValues.repaymentsRescheduledTo, "only-date")
      : formValues.repaymentsRescheduledTo;
    formValues.fromDate = formValues.fromDate
      ? BOM.DateTime(formValues.fromDate, "only-date")
      : formValues.fromDate;
    formValues.toDate = formValues.toDate
      ? BOM.DateTime(formValues.toDate, "only-date")
      : formValues.toDate;

    const url = `${apiConfig.Holidays}/${state.id}`;

    const body = {
      ...formValues,
      method: "PUT",
      session,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
    };

    setIsLoading(true);

    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.updateHolidayMsg);
          navigate("/manage-holidays", { state: state });

          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/manage-holidays", { state: state });
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.editHoliday}
        pageItems={staticConfig.editHolidayBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={useForm} layout="vertical" onFinish={onSubmit}>
            {holidayDetail?.status?.value === "Pending for activation" ? (
              <Row>
                {/* DETAILS  */}

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.name}
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.name),
                      },
                    ]}
                  >
                    <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.name)} />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.fromDate}
                    name="fromDate"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.fromDate),
                      },
                    ]}
                  >
                    <DatePicker
                      disabledDate={BOM.DisableBeforeCurrentDate}
                      placeholder={BOM.handlePlaceholderMsg(`${labelConfig.fromDate}`, "select")}
                      style={{
                        width: "100%",
                        height: 35,
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.toDate}
                    name="toDate"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.toDate),
                      },
                    ]}
                  >
                    <DatePicker
                      disabledDate={BOM.DisableBeforeCurrentDate}
                      placeholder={BOM.handlePlaceholderMsg(`${labelConfig.toDate}`, "select")}
                      style={{
                        width: "100%",
                        height: 35,
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.repaymentSchedulingType}
                    name="reschedulingType"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.repaymentSchedulingType),
                      },
                    ]}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.repaymentSchedulingType,
                        "select"
                      )}
                      options={rescheduleTypeData}
                      showSearch
                      // onChange={handleRepaymentSchedulingTypeChange}
                    />
                  </Form.Item>
                </Col>

                {isSpecifiedDateOption === 2 && (
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.repaymentScheduledTo}
                      name="repaymentsRescheduledTo"
                      rules={[
                        {
                          required: true,
                          message: BOM.CheckReqFld(labelConfig.repaymentScheduledTo),
                        },
                      ]}
                    >
                      <DatePicker
                        placeholder={BOM.handlePlaceholderMsg(
                          `${labelConfig.repaymentScheduledTo}`,
                          "select"
                        )}
                        style={{
                          width: "100%",
                          height: 35,
                        }}
                      />
                    </Form.Item>
                  </Col>
                )}

                <Divider />

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item label={labelConfig.description} name="description">
                    <TextArea placeholder={BOM.handlePlaceholderMsg(labelConfig.description)} />
                  </Form.Item>
                </Col>
              </Row>
            ) : (
              <Row>
                {/* DETAILS  */}

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.name}
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.name),
                      },
                    ]}
                  >
                    <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.name)} />
                  </Form.Item>
                </Col>

                <Divider />

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item label={labelConfig.description} name="description">
                    <TextArea placeholder={BOM.handlePlaceholderMsg(labelConfig.description)} />
                  </Form.Item>
                </Col>
              </Row>
            )}

            <Row>
              <Divider />
              {BOM.HasPermission("UPDATE_HOLIDAY") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
              )}

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default EditHoliday;
